import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from "@angular/router";

@Injectable({
  providedIn: 'root'
})
export class LowercaseUrlGuard implements CanActivate {
  constructor(private router: Router) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    debugger;
    const currentUrl = state.url;
    const lowerUrl = currentUrl.toLowerCase();

    if (currentUrl !== lowerUrl) {
      this.router.navigateByUrl(lowerUrl, {
        replaceUrl: true
      });
      return false;
    }

    return true;
  }
}
